import React, { KeyboardEvent } from 'react';
import { GridColumnMenuWrapperProps } from '@progress/kendo-react-grid';
import { 
  ColumnMenuStateProps
} from '@progress/kendo-react-grid/dist/npm/columnMenu/GridColumnMenuWrapper';
import { Keys } from '@progress/kendo-react-common';
import { Popup } from '@progress/kendo-react-popup';
import PuzzleButton from '../../UI/button/PuzzleButton';
import { COLUMN_MENU_WRAPPER } from './Types';
import { popupMenuWrapperHandleTabKeyDown } from '../../../utility/Util';

class ColumnMenuWrapper extends React.PureComponent<COLUMN_MENU_WRAPPER, ColumnMenuStateProps> {
  private anchorRef: React.RefObject<HTMLDivElement | null> = React.createRef();
  private buttonRef: React.RefObject<PuzzleButton | null> = React.createRef();
  private contentRef: React.RefObject<HTMLDivElement | null> = React.createRef();

  state = {
    show: false
  };

  private closeMenu = (preventFocus = false) => {
    this.setState({ show: false }, () => {
      if (preventFocus === false) {
        const buttonEl = this.buttonRef.current.buttonEl;
        if (buttonEl !== null) {
          buttonEl.focus();
        }
      }
    });
  };

  private onBlur = ({ currentTarget, relatedTarget }: React.FocusEvent) => {
    if (!currentTarget.contains(relatedTarget)) {
      this.setState({ show: false });
    }
  };

  /**
   * Open Popup
   * @param {React.MouseEvent<HTMLButtonElement, MouseEvent> | KeyboardEvent} event
   */
  private openPopup = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | KeyboardEvent) => {
    if (!this.state.show) {
      event.preventDefault();
      this.setState({
        show: true
      });
    }
  }

  /**
   * Open popup on press key Enter or press key space
   * @param {KeyboardEvent} e
   */
  private openPopupWithKeyboard = (e: KeyboardEvent) => {
    const { keyCode } = e;
    if (Keys.enter === keyCode || Keys.space === keyCode) {
      this.openPopup(e);
    }
  }

  private onKeyDown = (event: React.KeyboardEvent) => {
    switch (event.keyCode) {
      case Keys.esc:
        this.closeMenu();
        break;
      case Keys.tab:
        popupMenuWrapperHandleTabKeyDown(event, this.contentRef);
        break;
      default:
        break;
    }
  };

  render() {
    const {
      columnMenu: ColumnMenu,
      filterBtnAriaLabel,
      popupClassName,
      ...columnMenuProps
    } = this.props;
    return (
      <>
        <div
          className="k-grid-column-menu k-grid-filter"
          ref={this.anchorRef}
          style={{ position: 'absolute' }}
        >
          <PuzzleButton
            aria-label={filterBtnAriaLabel}
            data-cy={`column-menu-button-${columnMenuProps.column.field}`}
            fillMode="flat"
            iconClass="k-icon k-i-more-vertical"
            onKeyDown={this.openPopupWithKeyboard}
            onMouseDown={this.openPopup}
            ref={this.buttonRef}
            size="small"
          />
        </div>
        <Popup
          anchor={this.anchorRef.current}
          anchorAlign={{
            horizontal: 'right',
            vertical: 'bottom'
          }}
          popupAlign={{
            horizontal: 'right',
            vertical: 'top'
          }}
          show={this.state.show}
          className={popupClassName}
        >
          <div
            className="k-grid-columnmenu-popup tp-outline-none"
            data-cy={'popup-div'}
            onBlur={this.onBlur}
            onKeyDown={this.onKeyDown}
            ref={this.contentRef}
            tabIndex={0}
          >
            {
              ColumnMenu && (
                <ColumnMenu
                  {...columnMenuProps}
                  onCloseMenu={this.closeMenu}
                />
              )
            }
          </div>
        </Popup>
      </>
    );
  }
}

export default ColumnMenuWrapper;
